import styled from 'styled-components'

import { IconButton, Select, SelectOption, TypeStyle, fromMd } from '@syconium/little-miss-figgy'

import { swiperCSS } from '../../../../lib/shared-styles'

export const Body = styled.div`
  ${swiperCSS}

  position: relative;
  // clip (not hidden) so overflow-y: visible can coexist, letting dropdowns escape downward.
  overflow-x: clip;
  overflow-y: visible;
  margin-block: ${o => o.theme.spacing(5, 0)};

  // Bleed the carousel to the dialog edge on the trailing side only,
  // matching the CartInterstitialContent padding so slides run off-screen.
  margin-inline-end: ${o => `-${o.theme.spacing(4)}`};

  ${fromMd} {
    margin-inline-end: ${o => `-${o.theme.spacing(10)}`};
    margin-block: ${o => o.theme.spacing(6, 0)};
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${o => o.theme.spacing(4)};

  // Re-align trailing edge with dialog content after the bleed.
  padding-inline-end: ${o => o.theme.spacing(4)};

  ${fromMd} {
    padding-inline-end: ${o => o.theme.spacing(10)};
  }
`

export const Title = styled(TypeStyle.HeadlineExtraSmall)`
  font-size: 16px;
`

// Wraps the Swiper so controls can be absolutely positioned over the slides.
// overflow-x: clip (not hidden) preserves overflow-y: visible so dropdowns escape downward.
// We also override Swiper's own .swiper { overflow: hidden } and .swiper-slide defaults
// so content that overflows the fixed-height tile (e.g. open dropdowns) isn't clipped.
export const SwiperWrapper = styled.div`
  position: relative;
  overflow-x: clip;
  overflow-y: visible;

  & .swiper {
    overflow-x: clip;
    overflow-y: visible;
  }

  & .swiper-wrapper {
    overflow-y: visible;
  }

  & .swiper-slide {
    width: auto;
    overflow-y: visible;

    &:last-child {
      padding-inline-end: 12px;
    }
  }
`

const CarouselControlButton = styled(IconButton)`
  position: absolute;
  top: 33%;
  transform: translateY(-50%);
  z-index: 10;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.1);
`

export const PrevControl = styled(CarouselControlButton)`
  left: ${o => o.theme.spacing(1)};
`

export const NextControl = styled(CarouselControlButton)`
  right: ${o => o.theme.spacing(4)};

  ${fromMd} {
    right: ${o => o.theme.spacing(10)};
  }
`

export const Tile = styled.div`
  display: flex;
  background: ${o => o.theme.color.fill.background};
  border-radius: ${o => o.theme.spacing(2)};
  border: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  align-items: stretch;
  width: 308px;
`

export const Thumbnail = styled.div<{ $imgUrl: string }>`
  background: no-repeat center/cover url(${o => o.$imgUrl});
  width: 124px;
  align-self: stretch;
  border-radius: ${o => o.theme.spacing(2)} 0 0 ${o => o.theme.spacing(2)};
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${o => o.theme.spacing(3)};
`

export const DetailsText = styled.div`
  gap: ${o => o.theme.spacing(1)};
  margin-bottom: ${o => o.theme.spacing(2)};
`

export const DetailsActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(2)};
`

export const ProductName = styled(TypeStyle.HeadlineExtraExtraSmall)`
  font-size: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const PriceText = styled(TypeStyle.HeadlineExtraSmall)`
  font-size: 13px;
`

export const ColorText = styled.span`
  ${TypeStyle.css.headlineMicro};
  font-size: 11px;
  color: ${o => o.theme.color.text.tertiary.on.background};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const LoadingSpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 190px;
  background-color: ${o => o.theme.color.fill.subtle};
  border-radius: ${o => o.theme.spacing(2)};
  margin-inline-end: ${o => o.theme.spacing(4)};

  ${fromMd} {
    margin-inline-end: ${o => o.theme.spacing(10)};
  }
`

export const SizeSelector = styled(Select)`
  && {
    min-height: 32px;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.6px;
    color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  }

  ${IconButton} {
    min-width: 24px;
    min-height: 24px;
    color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  }
`

export const SizeSelectorOption = styled(SelectOption)`
  font-size: 12px;
`
